module.exports = __webpack_public_path__ + "static/media/home-slider-banner-7.dbd114b3.png";